import { Editor, Element } from 'slate';
import type { SlateEditor } from 'platejs';

import { options } from 'common/components/ContentEditor/options';
import {
    asEditor,
    unwrapBlockquote,
    type TTypedElement,
} from 'common/components/ContentEditor/utils/editorHelpers';

const isBlockquote = (n: unknown) =>
    Element.isElement(n) &&
    (n as TTypedElement).type === options.blockquote.type;

const isParagraph = (n: unknown) =>
    Element.isElement(n) && (n as TTypedElement).type === options.p.type;

/**
 * Slate's default insertBreak already does the right thing for a non-empty
 * line inside a quote (it splits the paragraph, leaving both halves nested
 * in the same blockquote). What's missing is a way out: pressing Enter on
 * an already-empty line inside a quote otherwise just keeps adding empty
 * paragraphs, unlike list items. Exit the blockquote in that case, mirroring
 * withListEnter.
 */
export const withBlockquoteEnter = ({
    editor,
    tf: { insertBreak },
}: {
    editor: Record<string, unknown>;
    tf: { insertBreak: () => void };
}) => {
    const slateEditor = asEditor(editor as SlateEditor);

    return {
        transforms: {
            insertBreak() {
                const [paragraphEntry] = Editor.nodes(slateEditor, {
                    match: isParagraph,
                    mode: 'lowest',
                });

                const [quoteEntry] = Editor.nodes(slateEditor, {
                    match: isBlockquote,
                });

                if (
                    !quoteEntry ||
                    !paragraphEntry ||
                    Editor.string(slateEditor, paragraphEntry[1])
                ) {
                    insertBreak();

                    return;
                }

                unwrapBlockquote(editor as SlateEditor);
            },
        },
    };
};
